<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>入职管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align: left; margin-bottom: 16px">
        <el-col :span="4">
          <el-input
            size="small"
            clearable
            v-model="searchName"
            placeholder="请输入姓名或部门"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="SearchByName"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="2" style="padding-left: 10px;">
          <el-button type="primary" size="small" @click="Refresh" plain
            >刷新</el-button
          >
        </el-col>
        <el-col style="text-align: right" :span="18">
          <el-button
            v-if="
              currentRole.Key != 'firstAduit' ||
              currentRole.Key != 'secondAduit'
            "
            type="primary"
            @click="launch"
            size="small"
            plain
            >发起入职</el-button
          >
          <el-button
            v-if="
              currentRole.Key != 'firstAduit' ||
              currentRole.Key != 'secondAduit'
            "
            type="primary"
            @click="sendEntryMessage"
            size="small"
            plain
            >批量发送入职短信</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="entryUserComplete"
            plain
            >入职资料批量通过</el-button
          >
          <el-button type="danger" size="small" @click="DeleteUser" plain
            >删除</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="userAllInfo"
            ref="multipleTable"
            style="width: 100%"
            v-loading="loading"
            size="small"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
              prop="sysUser.UserCode"
              label="工号"
              width="60"
            ></el-table-column>
            <el-table-column
              prop="sysUser.TrueName"
              label="姓名"
            ></el-table-column>
            <el-table-column label="部门">
              <template slot-scope="scope">
                <div>
                  <el-popover trigger="hover" placement="top">
                    <el-steps :space="200" :active="1" finish-status="success">
                      {{ scope.row.sysUser.FullPath }}
                    </el-steps>
                    <div slot="reference" class="name-wrapper">
                      <span>{{ scope.row.sysUser.MainDeptsName }}</span>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="sysUser.Phone"
              label="电话"
            ></el-table-column>
            <el-table-column
              prop="sysUser.PositionName"
              label="职务"
            ></el-table-column>
            <el-table-column
              prop="sysUser.DutyType"
              label="岗位类别"
            ></el-table-column>
            <el-table-column prop="sysUser.Duty" label="岗位"></el-table-column>
            <el-table-column
              prop="UserBaseInfo.RankName"
              label="薪级"
            ></el-table-column>
            <el-table-column
              prop="UserBaseInfo.LevelName"
              label="薪档"
            ></el-table-column>
            <el-table-column
              prop="UserBaseInfo.HiredDate"
              label="入职时间"
            ></el-table-column>
            <el-table-column
              prop="UserBaseInfo.SalaryDate"
              label="计薪时间"
            ></el-table-column>
            <el-table-column
              prop="UserBaseInfo.InsuranceStatus"
              :formatter="insuranceStatus"
              label="保险状态"
            ></el-table-column>
            <el-table-column
              prop="sysUser.FileStatus"
              :formatter="fileStatus"
              label="档案状态"
            ></el-table-column>
            <el-table-column
              prop="sysUser.Status"
              :formatter="status"
              label="审核状态"
            ></el-table-column>
            <el-table-column
              prop="sysUser.Demo"
              label="驳回原因"
            ></el-table-column>
            <el-table-column label="操作" fixed="right" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="bindUserInfo(scope.row)"
                  >查看</el-button
                >
                <el-button type="text" @click="editUserInfo(scope.row)"
                  >编辑</el-button
                >
                <!-- <el-button type="text" style="color:red;" @click='delUserInfo(scope.row)'>删除</el-button> -->
                <div
                  v-if="
                    currentRole.Key == 'admin' ||
                    currentRole.Key == 'firstAduit' ||
                    currentRole.Key == 'secondAduit' ||
                    currentRole.Key == 'HR'
                  "
                >
                  <el-button
                    type="text"
                    style="color: red"
                    @click="entryUserCompleteSingle(scope.row)"
                    >通过</el-button
                  >
                  <div
                    style="float: right; padding-right: 10px"
                    v-if="
                      (currentRole.Key == 'admin' &&
                        scope.row.sysUser.Status != 0 &&
                        scope.row.sysUser.Status != -2 &&
                        scope.row.sysUser.Status != -3) ||
                      currentRole.Key == 'firstAduit' ||
                      currentRole.Key == 'secondAduit'
                    "
                  >
                    <el-button
                      style="color: red"
                      type="text"
                      @click="backFile(scope.row)"
                      >驳回</el-button
                    >
                  </div>
                </div>
                <!-- <div v-if="currentRole.Key=='recruit' && scope.row.sysUser.Status != 5 && scope.row.sysUser.Status != 6">
                        <el-button type="text" style="color:red;" @click='entryUserCompleteSingle(scope.row)'>通过</el-button>
                    </div> -->
                <div
                  v-if="
                    currentRole.Key.indexOf('recruit') != -1 &&
                    scope.row.sysUser.Status != 5 &&
                    scope.row.sysUser.Status != 6
                  "
                >
                  <el-button
                    type="text"
                    style="color: red"
                    @click="entryUserCompleteSingle(scope.row)"
                    >通过</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="text-align: right; margin-top: 6px" :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float: right"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import {
  GetSysUserPageList,
  EntryUserComplete,
  SendBackMessage,
  SendEntryMessage,
  TransDeleteUser,
} from "../../until/ZeusApiSDK/Logic/SysUserLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { EnqueueDelUser } from "../../until/ZeusApiSDK/Logic/LogLogic";
export default {
  data() {
    return {
      currentUser: {}, //当前用户
      currentRole: {}, //当前用户角色
      userAllInfo: [], //数据信息
      searchName: "", //搜索信息
      name: "", //
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      visible: false,
    };
  },
  created() {
    //获取当前用户信息
    this.getCurrentUser();
    //获取当前用户角色
    this.getCurrentRole();
    //获取当前入职状态列表
    this.GetSysUserPageList();
  },
  methods: {
    //获取当前用户
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSysUserPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetSysUserPageList();
    },
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetSysUserPageList();
    },
    //刷新
    Refresh: function () {
      this.GetSysUserPageList();
    },
    GetSysUserPageList: function () {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      GetSysUserPageList(
        this.currentUser.UserId,
        this.currentRole.Key,
        this.currentUser.FrameId,
        this.currentRole.OtherFrameID,
        this.searchName == "" ? null : this.searchName,
        this.currentRole.DataAuth,
        //'606',
        this.pageIndex,
        this.pageSize
      ).then((res) => {
        this.loading = false;
        this.userAllInfo = res.List;
        this.totalCount = res.TotalCount;
      });
    },
    //档案状态
    fileStatus(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "已补全";
      } else if (cellValue == 0) {
        return "待完善";
      } else if (cellValue == 2) {
        return "驳回修改";
      }
    },
    //保险状态
    insuranceStatus(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    //审核状态
    status(row, column, cellValue, index) {
      if (cellValue == 6) {
        return "已提交";
      } else if (cellValue == -2) {
        return "初审驳回";
      } else if (cellValue == -3) {
        return "二审驳回";
      } else if (cellValue == 5) {
        return "初审通过";
      } else if (cellValue == 0) {
        if (row.sysUser.FileStatus == "1") {
          return "已补全";
        } else {
          return "待完善";
        }
      }
    },
    //查看用户信息
    bindUserInfo: function (data) {
      this.$router.push(
        "/SysUser/UserInfo?UserID=" + data.sysUser.Id + "&name=入职管理"
      );
    },
    //编辑用户信息
    editUserInfo: function (data) {
      this.$router.push(
        "/SysUser/EditUserInfo?UserID=" + data.sysUser.Id + "&name=入职管理"
      );
    },
    //审核通过
    entryUserCompleteSingle: function (data) {
      this.loading = true;

      EntryUserComplete(data.sysUser.Id, this.currentRole.Key).then((res) => {
        if (res.Result == 1) {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
          this.GetSysUserPageList();
        } else {
          this.$message({
            showClose: true,
            message: "操作失败",
            type: "error",
          });
          this.GetSysUserPageList();
        }
      });
    },
    //审核驳回
    backFile: function (data) {
      this.loading = true;
      this.$prompt("请输入驳回原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "请输入驳回原因",
      })
        .then(({ value }) => {
          //驳回入职信息
          SendBackMessage(data.sysUser.Id, this.currentRole.Key, value).then(
            (res) => {
              if (res) {
                this.GetSysUserPageList();
              }
            }
          );
        })
        .catch(() => {});
    },
    //发起入职
    launch: function () {
      this.$router.push("/SysUser/AddUser");
    },
    //批量发送入职短信
    sendEntryMessage: function () {
      var userArray = this.$refs.multipleTable.selection;
      if (userArray <= 0) {
        this.$message({
          type: "error",
          message: "请选择操作项",
        });
        return false;
      }
      this.loading = true;
      var ids = "";
      userArray.forEach((item) => {
        ids += item.sysUser.Id + ",";
      });
      //发送入职短信
      SendEntryMessage(
        ids,
        this.currentUser.UserId,
        this.currentUser.TrueName
      ).then((res) => {
        if (res) {
          this.GetSysUserPageList();
        }
      });
    },
    //入职资料批量通过
    entryUserComplete: function () {
      var userArray = this.$refs.multipleTable.selection;
      if (userArray <= 0) {
        this.$message({
          type: "error",
          message: "请选择操作项",
        });
        return false;
      }
      this.loading = true;
      var ids = "";
      userArray.forEach((item) => {
        ids += item.sysUser.Id + ",";
      });
      //入职资料审核通过
      EntryUserComplete(ids, this.currentRole.Key).then((res) => {
        if (res) {
          this.GetSysUserPageList();
        }
      });
    },
    //删除人员
    DeleteUser: function () {
      this.$confirm("此操作将永久删除信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var userArray = this.$refs.multipleTable.selection;
          if (userArray <= 0) {
            this.$message({
              type: "error",
              message: "请选择操作项",
            });
            return false;
          }
          this.loading = true;
          var ids = "";
          userArray.forEach((item) => {
            ids += item.sysUser.Id + ",";
          });

          //删除当前人员
          TransDeleteUser(ids).then((res) => {
            //删除成功 添加日志 并刷新列表
            this.GetSysUserPageList();

            userArray.forEach((item) => {
              this.addLog(item.sysUser, "删除入职成功");
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //添加日志
    addLog: function (formInfo, info) {
      //编辑sysUser成功，添加日志
      EnqueueDelUser(
        "删除入职信息sysUser",
        this.currentUser.UserId,
        this.currentUser.TrueName,
        "删除入职信息",
        info,
        formInfo.Id,
        {},
        formInfo,
        "userInfo"
      );
    },
  },
};
</script>

